import { Field, ID, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import type { ChatMessage } from '../Chat'
import { BaseChatMessageArgs } from './BaseChatMessageArgs'

@InputType()
export class AddChatMessageArgs extends BaseChatMessageArgs {
  // Optional order link supplied on compose — carried onto the new conversation's metadata.orderId.
  @Field(() => ID, { nullable: true })
  orderId?: string
}
export interface IAddChatMessage extends IAction<ChatMessage, AddChatMessageArgs> {}
